import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { throwError, catchError } from 'rxjs';
import { PortalAuthenticationService } from '@service/b2b-portal/portal-authentication/portal-authentication.service';
import { ToastService } from '@shared/service/toast.service';
import { HEADER_CONSTANTS } from '@shared/constants/header.constants';
import { environment } from '@env/environment';
import { shouldBypassInterceptor, isLoginRequest } from './interceptor.utils';

export const b2bPortalInterceptor: HttpInterceptorFn = (request, next) => {
  if (shouldBypassInterceptor(request)) {
    return next(request);
  }

  const b2bAuthService = inject(PortalAuthenticationService);
  const toastService = inject(ToastService);

  const isLogin = isLoginRequest(request);

  const skipAuthHeader = ['/login', '/validate-otp', '/resend-otp'].some(path =>
    request.url.includes(path)
  );

  const b2bHeaders: Record<string, string> = {
    [HEADER_CONSTANTS.BANK_IDENTIFICATION]:
      environment.bankIdentificationEntity ?? '0109',
    [HEADER_CONSTANTS.CORRELATION_ID]: `b2b-portal-${crypto.randomUUID()}`,
    [HEADER_CONSTANTS.BUSINESS_CHANNEL]: 'DIGITAL',
    [HEADER_CONSTANTS.BUSINESS_SUB_CHANNEL]: 'INTERNETBANKING',
    [HEADER_CONSTANTS.APP_ID]: 'b2b-portal',
  };

  if (!skipAuthHeader) {
    const sessionData = b2bAuthService.getSessionData();
    const token = sessionData?.access_token || null;

    if (token) {
      b2bHeaders[HEADER_CONSTANTS.AUTHORIZATION] = `Bearer ${token}`;
    }
  }

  const modifiedRequest = request.clone({
    setHeaders: b2bHeaders,
  });

  return next(modifiedRequest).pipe(
    catchError((error: any) => {
      if (error instanceof HttpErrorResponse) {
        if (!isLogin && error.status === 401) {
          toastService.showError(
            'Session abgelaufen, bitte melden Sie sich erneut an.'
          );
        }
      }

      return throwError(() => error);
    })
  );
};
